var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubnetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-subnetwork-1{fill:#aecbfa;}.cls-subnetwork-2{fill:#669df6;}.cls-subnetwork-3{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_VirtualPrivateCloud_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-1",
    x: 16,
    y: 2,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 19,
    y: 2,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-1",
    x: 16,
    y: 16,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 19,
    y: 16,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-1",
    x: 2,
    y: 2,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 5,
    y: 2,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-1",
    x: 2,
    y: 16,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 5,
    y: 16,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 8,
    y: 4,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 8,
    y: 18,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 18,
    y: 8,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-2",
    x: 4,
    y: 8,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-3",
    x: 4,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-3",
    x: 18,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-3",
    x: 8,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-subnetwork-3",
    x: 8,
    y: 18,
    width: 2,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubnetwork);
export default __webpack_public_path__ + "static/media/subnetwork.8daad3616937c11db928106a6ceaccca.svg";
export { ForwardRef as ReactComponent };